import '../asset/main.css'
import imagecover from '../asset/images/15.png'
import AddIcon from 'remixicon-react/AddCircleLineIcon'
import Close from 'remixicon-react/CloseLineIcon'
import Upload from 'remixicon-react/UploadCloudFillIcon'
import Bin from 'remixicon-react/DeleteBinLineIcon'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useState } from 'react'



import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useEffect, useRef } from 'react';

import { useSpring, animated } from 'react-spring';

import { ref, uploadBytes, getDownloadURL, uploadBytesResumable } from 'firebase/storage';

import { app, storage } from '../firebase'


import { addabout, getAbout } from '../firebase'

const initialData = [

]

const initialDataHb = [

]
export default function AddAbout({ onHideBox }) {

    const handleHideBox = () => {
        onHideBox();
    };
    const [dataEx, setDataEx] = useState(initialData)

    const [dataHb, setDataHb] = useState(initialDataHb)


    const [dataAbout, setDataAbout] = useState({})


    const [nameEx, setNameEx] = useState('');
    const [nameDescEx, setNameDescEx] = useState('');
    const [nameHB, setNameHB] = useState('');

    const tbodyRef = useRef(null);

    const [progress, setProgress] = useState(0);




    const addCollab = () => {
        const dataCollection = [
            ...dataEx,
            {
                nameEx: nameEx ? nameEx : '',
                nameDescEx: nameDescEx ? nameDescEx : ''
            }
        ]

        setDataEx(dataCollection)
        console.log(dataCollection)

    }
    useEffect(() => {
        setDataAbout({
            ...dataAbout,
            listEx: dataEx
        })
    }, [dataEx])

    const handleDeleteEx = (index) => {
        const newDataCollab = dataEx.filter((_, i) => i !== index);
        setDataEx(newDataCollab);

        console.log(newDataCollab)
    };

    const addHb = () => {
        const dataCollection = [
            ...dataHb,
            {
                nameHB: nameHB ? nameHB : '',
            }
        ]
        setDataHb(dataCollection)
        console.log(dataHb)
    }


    useEffect(() => {
        setDataAbout({
            ...dataAbout,
            listHob: dataHb
        })
    }, [dataHb])


    const handleDeleteHB = (index) => {
        const newDataHb = dataHb.filter((_, i) => i !== index);
        setDataHb(newDataHb);
        console.log(newDataHb)
    };



    const [imgData, setImageData] = useState();
    const [avatar, setAvatar] = useState()

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        setAvatar(file)

        if (file) {
            const reader = new FileReader();

            reader.onload = () => {
                const dataURL = reader.result;
                setImageData(dataURL);

                console.log(imgData)

            };

            reader.readAsDataURL(file);
        }

    };


    const uploadImage = () => {
        if (avatar) {
            const storageRef = ref(storage, `avartar/${avatar.name}`);
            const uploadTask = uploadBytesResumable(storageRef, avatar);

            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    setProgress(progress); 
                },
                (error) => {
                    console.error(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        setDataAbout({
                            ...dataAbout,
                            avatar: downloadURL
                        })

                    });
                }
            );
        } else {
            console.log('No image selected');
        }
    };

    const handleAddAbout = () => {
        console.log(dataAbout)
        addabout(dataAbout).then((e) => {
            alert("Successfully!")
        })
            .catch((error) => {
                console.log("ERROR: " + error)
            })
    }

    return (
        <div className="addproject">
            <div className="button-close">
                <div className="wrap-button_close" onClick={handleHideBox}>
                    <Close size={40} color='#585858'></Close>
                </div>
            </div>
            <div className="wrap-addproject">
                <div className="addproject-left">

                    <div className="wrap-addproject-left">

                        <div className="addproject-left_description">
                            <h2>About me</h2>
                            <textarea onChange={(text) => {
                                setDataAbout({
                                    ...dataAbout,
                                    aboutme: text.target.value
                                })
                            }}></textarea>
                        </div>

                        <div className="wrap-button-addfile">
                            <input type="file"
                                onChange={handleFileChange} />

                            <div className="progress-bar" style={{ width: `${progress}%` }}>
                            </div>
                        </div>

                        <div className="addproject-left_uploadimg">
                            <div className="option-image_buttonup" onClick={uploadImage}>
                                <Upload color='#585858' size={34} ></Upload>
                            </div>
                            <div className="wrap-previewimage">
                                <h2>Avatar</h2>
                                <div className="wrap-previewimage_picture">
                                    <img src={imgData ? imgData : imagecover} alt="Preview" />
                                </div>
                            </div>
                        </div>


                        <div className="wrap-addcoordinate">
                            <h2>Coordinate</h2>
                            <input type="text" onChange={(value) => {
                                setDataAbout({
                                    ...dataAbout,
                                    coordiante: value.target.value
                                })
                            }} />
                        </div>

                        <div className="addproject-right_collaborator">
                            <h2>Experience</h2>

                            <div className="wrap_header-position-about">
                                <input type="text" onChange={(value) => {
                                    setNameEx(value.target.value)
                                }} />

                                <div className="option-position_buttonadd" onClick={addCollab}>
                                    <AddIcon size={40} color='#585858'></AddIcon>
                                </div>
                            </div>

                        </div>


                    </div>

                </div>


                <div className="space-addproject"></div>

                <div className="addproject-right">
                    <div className="addproject-right_ex">
                        <div className="wrap-addproject-right">
                            <div className="addproject-right_collaborator">
                                <h2>Describe the experience</h2>

                                <div className="wrap-desc-ex">
                                    <textarea type="text" onChange={(value) => {
                                        setNameDescEx(value.target.value)
                                    }} />
                                </div>
                            </div>
                        </div>

                        <div className="addproject-right_resultadd">
                            <div className="addproject-right_resultadd-wrap">
                                <div className="table-container-about">
                                    <table width="100%" border="1" cellpadding="5">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Description</th>
                                                <th>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody ref={tbodyRef}>
                                            {dataEx.map((data, index) => (
                                                <tr key={index} className='row-of-collab'>
                                                    <td>{data.nameEx}</td>
                                                    <td>{data.nameDescEx}</td>
                                                    <td className='button-bin' onClick={() => { handleDeleteEx(index) }}><Bin></Bin></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="addproject-right_hb">
                        <div className="wrap-addproject-right">
                            <div className="addproject-right_collaborator">
                                <h2>Hobbies</h2>

                                <div className="wrap_header-position-about">
                                    <input type="text" onChange={(value) => {
                                        setNameHB(value.target.value)
                                    }} />
                                    <div className="option-position_buttonadd" onClick={addHb}>
                                        <AddIcon size={40} color='#585858'></AddIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="addproject-right_resultadd">
                            <div className="addproject-right_resultadd-wrap">
                                <div className="table-container-about">
                                    <table width="100%" border="1" cellpadding="5">
                                        <thead>
                                            <tr>
                                                <th>Hobbies</th>
                                                <th>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {dataHb.map((data, index) => (
                                                <tr key={index} className='row-of-collab'>
                                                    <td>{data.nameHB}</td>
                                                    <td className='button-bin' onClick={() => { handleDeleteHB(index) }}><Bin></Bin></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrap-button-addproject"  >
                        <input type="button" value="Save" onClick={handleAddAbout} />
                    </div>
                </div>
            </div>
        </div>

    )
}